import { render, staticRenderFns } from "./MechanicForm.vue?vue&type=template&id=312664b2"
import script from "./MechanicForm.vue?vue&type=script&lang=js"
export * from "./MechanicForm.vue?vue&type=script&lang=js"
import style0 from "./MechanicForm.vue?vue&type=style&index=0&id=312664b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports